"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopAreaBannerType = exports.MY_PAGES_REGEX = exports.CHECKOUT_REGEX = void 0;
var _net = require("../../../models/graphql-types/net");
const MY_PAGES_REGEX = exports.MY_PAGES_REGEX = /^\/([A-Za-z]{2}\/)?mypages(\/.*|\?.*)?$/;
const CHECKOUT_REGEX = exports.CHECKOUT_REGEX = /^\/([A-Za-z]{2}\/)?shopping\/basket(\/.*|\?.*)?$/;
const getTopAreaBannerType = pathname => {
  if (pathname === null) {
    return null;
  }
  if (MY_PAGES_REGEX.test(pathname)) {
    return _net.PermanentTopBannerType.MyPages;
  }
  if (CHECKOUT_REGEX.test(pathname)) {
    return _net.PermanentTopBannerType.Checkout;
  }
  return _net.PermanentTopBannerType.PublicPage;
};
exports.getTopAreaBannerType = getTopAreaBannerType;
